// extracted by mini-css-extract-plugin
export default {"container":"MessageSimulation_container__mR7sg","data-info":"MessageSimulation_data-info__2uiyg","data-info-content":"MessageSimulation_data-info-content__czR6F"};